module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-73.dd1fd3cd.svg";